"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _usePortal = require("../../_helpers/usePortal");

var _reactSpring = require("react-spring");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Modal.css");

var _styles = {
  "container": "Modal__container___12pr7",
  "auto-scroll": "Modal__auto-scroll___2GgqK",
  "mobile-top": "Modal__mobile-top___2Vd2C",
  "show": "Modal__show___1ynIX",
  "rounded": "Modal__rounded___poTEK",
  "close-button": "Modal__close-button___1QgmX",
  "animated-container": "Modal__animated-container___2F_I7",
  "backdrop": "Modal__backdrop___2bSUQ"
};

const styles = _bind.default.bind(_styles);

const Modal = (0, _mobxReact.observer)(({
  className,
  children,
  showModal,
  closeToggle,
  dataTestId,
  maxWidth,
  backdrop = true,
  mobilePositionTop = false,
  rounded = false
}) => {
  const [autoScroll, setAutoScroll] = (0, _react.useState)(false);
  const transitions = (0, _reactSpring.useTransition)(showModal, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  const contentRef = (0, _react.useRef)(null);
  const composed_classname = (0, _bind.default)(styles('container', {
    show: showModal,
    'mobile-top': mobilePositionTop,
    'auto-scroll': autoScroll,
    rounded
  }));
  (0, _react.useEffect)(() => {
    document.body.style.overflow = showModal ? 'hidden' : 'visible';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, [showModal]);
  (0, _react.useEffect)(() => {
    if (contentRef.current) {
      if (contentRef.current.clientHeight > window.innerHeight) {
        setAutoScroll(true);
      } else {
        setAutoScroll(false);
      }
    }
  }, [contentRef.current]);
  return _react.default.createElement(_usePortal.Portal, {
    id: 'root',
    className: className,
    "data-testid": dataTestId
  }, transitions((props, item) => {
    return item && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactSpring.animated.div, {
      className: styles('animated-container', {
        'mobile-top': mobilePositionTop
      }),
      style: props
    }, backdrop && _react.default.createElement("div", {
      className: styles('backdrop', {
        show: showModal
      }),
      onClick: backdrop === 'static' ? () => null : closeToggle
    }), _react.default.createElement(_.Card, {
      className: composed_classname,
      maxWidth: maxWidth,
      "data-testid": dataTestId
    }, _react.default.createElement("div", {
      ref: contentRef
    }, closeToggle && _react.default.createElement(_.Icon, {
      className: styles('close-button'),
      name: _.IconEnum.x_mark,
      onClick: closeToggle
    }), children))));
  }));
});
var _default = Modal;
exports.default = _default;